import styled from 'styled-components';

import { Waves as BasedWaves } from '~/src/common/components/Logo';
import { CATALOG_SIDE_PADDING } from '~/src/screens/App/CatalogLayout/layout';
import { MobileIncentiveBanner } from '~/src/screens/Home/MobileIncentiveBanner/MobileIncentiveBanner';
import { media } from '~/src/styles-constants';

export const Waves = styled(BasedWaves)`
  margin-bottom: 0;
`;

export const HomeTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-top: 16px;

  & > h1 {
    text-align: center;
    margin: 16px 0 0;
  }
`;

export const MobileIncentive = styled(MobileIncentiveBanner)`
  margin-left: -${CATALOG_SIDE_PADDING}px;
  margin-right: -${CATALOG_SIDE_PADDING}px;

  ${media.M`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const FooterContentContainer = styled.div`
  margin-top: 58px;
  margin-bottom: 48px;
`;

export const ToasterMessage = styled.div`
  font-size: 12px;
  line-height: 16px;

  & > p:last-child {
    font-weight: 500;
  }
`;
